import { useIntl } from '@capsicum/common';

import { AvailableWalletBalanceDrawer } from '../avalable-wallet-balance-drawer';
import { GenericDrawer } from '../generic-drawer/GenericDrawer';

export type InsufficientChilizBalanceModalProps = {
	closeModal: () => void;
	formattedAltWalletBalance: string;
	onButtonPress: () => void;
	onSecondaryActionOnButtonPress: () => void;
	walletBalance: number;
	walletCurrency: string;
};

export const InsufficientChilizBalanceModal = ({
	formattedAltWalletBalance,
	onButtonPress,
	onSecondaryActionOnButtonPress,
	walletBalance,
	walletCurrency
}: InsufficientChilizBalanceModalProps) => {
	const { $t } = useIntl();

	return (
		<GenericDrawer
			buttonText={$t('global.insufficientChilizBalance.buttonText')}
			description={$t('global.insufficientChilizBalance.description')}
			isButtonOnRow={false}
			secondaryActionButtonText={$t('global.insufficientChilizBalance.secondaryButtonText')}
			testID="FanTokenStaking-insufficientChilizBalanceDrawer"
			title={$t('global.insufficientChilizBalance.title')}
			onButtonPress={onButtonPress}
			onSecondaryActionOnButtonPress={onSecondaryActionOnButtonPress}
		>
			<AvailableWalletBalanceDrawer
				formattedAltWalletBalance={formattedAltWalletBalance}
				showDivider={false}
				walletBalance={walletBalance}
				walletCurrency={walletCurrency}
			/>
		</GenericDrawer>
	);
};
